
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface LessonsGridEmptyProps {
  onBack: () => void;
  pathId: string;
  moduleTitle?: string;
}

/**
 * LessonsGridEmpty component - displays empty state when no lessons are found
 * Shows helpful message explaining that content is still being developed
 */
export const LessonsGridEmpty = ({ onBack, pathId, moduleTitle }: LessonsGridEmptyProps) => {
  console.warn("⚠️ No lessons found for module:", pathId);
  
  return (
    <div className="space-y-8 animate-fade-in">
      {/* Back Button */}
      <div className="flex items-center gap-4 px-8">
        <Button
          variant="ghost"
          onClick={onBack}
          className="group hover:bg-gray-100 -ml-2"
        >
          <ArrowLeft className="h-5 w-5 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to Module
        </Button>
      </div>

      <div className="text-center max-w-md mx-auto px-8">
        <div className="mb-6">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mb-2">No lessons found</h2>
          <p className="text-gray-600 mb-4">
            This module ({moduleTitle || 'Unknown'}) doesn't have any lessons yet. 
            Content is still being developed for this section.
          </p>
          <p className="text-sm text-gray-500 mb-2">
            Module ID: {pathId}
          </p>
          <p className="text-sm text-gray-500">
            Check the console for detailed debugging information.
          </p>
        </div>
      </div>
    </div>
  );
};
